import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    Lane,
} from 'app/Apps/Pricing/Pricing.types'
import {
    LaneStatus,
} from 'app/enums/label.enums'

const columns: RichTableColumns<keyof Lane>[] = [
    {
        id: 'laneNumber',
        headerProps: {
            children: 'Lane',
        },
        mapCellProps: 'laneNumber',
    },
    {
        id: 'originAirportIataCode',
        headerProps: {
            children: 'Origin Airport',
        },
        mapCellProps: 'originAirportIataCode',
        filterField: 'originAirportIataCode',
        filterType: FilterType.Array,
    },
    {
        id: 'destAirportIataCode',
        headerProps: {
            children: 'Destination Airport',
        },
        mapCellProps: 'destAirportIataCode',
        filterField: 'destAirportIataCode',
        filterType: FilterType.Array,
    },
    {
        id: 'consigneeLocationName',
        headerProps: {
            children: 'Consignee',
        },
        mapCellProps: 'consigneeLocationName',
        filterField: 'consigneeLocationName',
        filterType: FilterType.Array,
    },
    {
        id: 'laneStatus',
        headerProps: {
            children: 'Status',
        },
        mapCellProps: 'laneStatus',
        filterField: 'laneStatus',
        filterType: FilterType.Array,
        componentName: 'EnumValue',
        allowedValuesEnum: LaneStatus,
    },
    {
        id: 'customerExecutionLocationName',
        headerProps: {
            children: 'Customer (Execution)',
        },
        mapCellProps: 'customerExecutionLocationName',
    },
]

export default columns
